(function () {
  var KEY = 'rfqqq_quote_list';
  var root = document.querySelector('[data-rfqqq-parts], .rq-home');
  if (!root) return;
  function readList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function writeList(l) {
    localStorage.setItem(KEY, JSON.stringify(l));
    document.querySelectorAll('[data-rfqqq-quote-count]').forEach(function (el) { el.textContent = l.length; el.hidden = l.length === 0; });
  }
  function flash(btn, text, cls) {
    var orig = btn.getAttribute('data-orig') || btn.textContent; btn.setAttribute('data-orig', orig);
    btn.textContent = text; btn.classList.add(cls);
    setTimeout(function () { btn.textContent = orig; btn.classList.remove(cls); }, 1800);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rfqqq-quote-add]'); if (!b) return;
    var p; try { p = JSON.parse(b.getAttribute('data-product')); } catch (err) { return; }
    var offers = []; try { offers = JSON.parse(b.getAttribute('data-offers')) || []; } catch (err) {}
    var v = (p.variants && p.variants[0]) || {};
    var qtyEl = b.closest('.rq-card') && b.closest('.rq-card').querySelector('.rq-qty');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    var list = readList();
    var existing = list.filter(function (x) { return x.variantId === v.id; })[0];
    if (existing) { existing.qty += qty; } else {
      list.push({ handle: p.handle, title: p.title, mpn: b.getAttribute('data-mpn') || '', url: '/products/' + p.handle, variantId: v.id, ourPrice: (v.price || 0) / 100, qty: qty, offers: offers, added: Date.now() });
    }
    writeList(list);
    flash(b, existing ? 'Qty ' + existing.qty + ' in quote' : 'Added to quote', 'is-done');
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-rq-cart-form]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json(); })
      .then(function (r) {
        if (r.status) { flash(btn, r.description || 'Error', 'is-error'); return; }
        return fetch('/cart.js').then(function (c) { return c.json(); }).then(function (c) {
          flash(btn, 'Added ✓', 'is-done');
          document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) { el.textContent = c.item_count; });
          var bubble = document.querySelector('#cart-icon-bubble');
          if (bubble && !bubble.querySelector('.cart-count-bubble')) {
            var d = document.createElement('div'); d.className = 'cart-count-bubble'; d.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>'; bubble.appendChild(d);
          }
        });
      })
      .catch(function () { flash(btn, 'Could not add', 'is-error'); });
  });

  var ff = document.querySelector('[data-rq-filter-form]');
  if (ff) {
    ff.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams();
      new FormData(ff).forEach(function (v, k) { if (v !== '' && v != null) params.append(k, v); });
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  }
  var ft = document.querySelector('[data-rq-filters-toggle]');
  if (ft) ft.addEventListener('click', function () {
    var panel = document.getElementById('rq-filters-panel');
    var open = panel.classList.toggle('is-open');
    ft.setAttribute('aria-expanded', open ? 'true' : 'false');
    ft.textContent = open ? 'Hide filters' : 'Filters';
  });

  var grid = document.querySelector('[data-rq-grid]');
  if (grid) {
    var saved = null; try { saved = localStorage.getItem('rfqqq_view'); } catch (e) {}
    function setView(v) {
      grid.classList.toggle('is-list', v === 'list');
      document.querySelectorAll('[data-rq-view]').forEach(function (b) { var on = b.getAttribute('data-rq-view') === v; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      try { localStorage.setItem('rfqqq_view', v); } catch (e) {}
    }
    if (saved) setView(saved);
    document.addEventListener('click', function (e) { var b = e.target.closest('[data-rq-view]'); if (b) setView(b.getAttribute('data-rq-view')); });
  }
})();
